import { html, nothing } from "lit";
import { ExportPdfModal } from "./export-pdf-modal";
import { translate } from "../../../localization";

export const template = (props: ExportPdfModal) => {
  const { arrayElements, text } = props;
  return html`
        <div class="wrapper">
            <!-- <dss-input-dropdown type="default" .elements=${arrayElements} selectall="" dropdownplaceholder="Seleccionar" 
            @onInputDropdownChange=${(e) => {
              props.selectedVisibilityLevelElement = e.detail;
            }}>
                <label slot="label" for="dropdown1">Selecciona periode</label>
                <input id="dropdown1" slot="input" type="text" class="dss-input" />
            </dss-input-dropdown> -->
            <div class="content-options">
              <div class="selector-options">
                <dss-radio-button>
                  <input slot="input" id="radioButton1" type="radio" name="exportOption" @change=${() => {
                    props.selectedRadioOption = "history";
                  }}>
                  <label slot="label" for="radioButton1">${translate("modal.allActivityHistory")}</label>
                </dss-radio-button>
                <dss-radio-button>
                  <input slot="input" id="radioButton2" type="radio" name="exportOption" @change=${() => {
                    props.selectedRadioOption = "filters";
                  }}>
                  <label slot="label" for="radioButton2">${translate("modal.onlyAppliedFilters")}</label>
                </dss-radio-button>
              </div>
            </div>
            ${
              props.selectedRadioOption
                ? html`<div class="content-date">
                <span>${translate("modal.selectDateRange")}</span>
                <div class="datepicker-canvas">
                  <dss-datepicker-range inputsize="md" @onRangeChange=${(e) => {
                    props.selectedPeriodDate = e.detail;
                  }} helpText=${translate("modal.helpText")}>
                    <label slot="label-range-start" for="myDatepickerRangeStart">${translate("modal.startDate")}</label>
                    <input slot="input-range-start" id="myDatepickerRangeStart" type="text" class="dss-input">
                    <label slot="label-range-end" for="myDatepickerRangeEnd">${translate("modal.endDate")}</label>
                    <input slot="input-range-end" id="myDatepickerRangeEnd" type="text" class="dss-input">
                  </dss-datepicker-range>
                </div>
              </div>`
                : nothing
            }
        </div>`;
};
